import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dd2f0e46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "el-menu--horizontal"
};
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'peopleheader',
  setup(__props) {
    const activeIndex2 = ref("1");
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
        "default-active": activeIndex2.value,
        class: "el-menu-demo",
        mode: "horizontal",
        "background-color": "grey",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
        router: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/webpage/people/Mdata"
        }, {
          default: _withCtx(() => [_createTextVNode("运动数据")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Tanalysis"
        }, {
          default: _withCtx(() => [_createTextVNode("技术分析")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Ppk"
        }, {
          default: _withCtx(() => [_createTextVNode("个人PK")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/ltcomp"
        }, {
          default: _withCtx(() => [_createTextVNode("擂台赛")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Systemnotice"
        }, {
          default: _withCtx(() => [_createTextVNode(" 系统通知")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Minfo"
        }, {
          default: _withCtx(() => [_createTextVNode("本人信息")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Finfo"
        }, {
          default: _withCtx(() => [_createTextVNode("好友信息")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/webcomp"
        }, {
          default: _withCtx(() => [_createTextVNode(" 我的比赛")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Mcomment"
        }, {
          default: _withCtx(() => [_createTextVNode(" 我的评论")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Mteam"
        }, {
          default: _withCtx(() => [_createTextVNode("我的团队")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Mteacher"
        }, {
          default: _withCtx(() => [_createTextVNode(" 我的私教")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/webpage/people/Mfile"
        }, {
          default: _withCtx(() => [_createTextVNode(" 私人文件")]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"])]);
    };
  }
});